import React from "react";
import Modal from 'react-bootstrap/Modal';
import { withTranslation } from 'react-i18next';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { toast } from 'react-toastify';

import ClassRoomItem from "../../School/Missions/ClassRoomItem";
import api from '../../../api/api';
import { ShareMissionBySocket } from '../../../api/realtime';
import LessonQuestionsList from "../Tracks/LessonQuestionsList";
import "../Tracks/LessonView/LessonResult/summary.css";

class SendMissionForm extends React.Component {

    state = {
        currentStep: 1,
        Id: 0,
        date: "",
        SelectCustomeQuestions: false,
        selectedStudent: [],
        SelectedQuestions: [],
        startDate: "",
        endDate: "",
        TimeHour: 0,
        TimeMinutes: 0,
        TimeType: 'continue',
        isFirst: true,
        GameSave: "default",
        GamePlay: "default",
        classSearchTerm: ""
    };

    constructor(props) {
        super(props);
        moment.locale('en');
        this._toastId = new React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.item && state.isFirst) {
            state.Id = props.item.Id;
            state.selectedStudent = [];
            state.startDate = props.item.StartDate || "";
            state.endDate = props.item.EndDate || "";
            state.TimeHour = props.item.CustomStyle && props.item.CustomStyle.Clock ? (props.item.CustomStyle.Clock.TimeHour ?? 0) : 0;
            state.TimeMinutes = props.item.CustomStyle && props.item.CustomStyle.Clock ? (props.item.CustomStyle.Clock.TimeMinutes ?? 0) : 0;
            state.TimeType = props.item.CustomStyle && props.item.CustomStyle.Clock ? (props.item.CustomStyle.Clock.TimeType ?? "continue") : "continue";
            state.GamePlay = props.item.CustomStyle ? (props.item.CustomStyle.GamePlay ?? "default") : "default";
            state.GameSave = props.item.CustomStyle ? (props.item.CustomStyle.GameSave ?? "default") : "default";

            if (props.item.Students && Array.isArray(props.item.Students)) {
                props.item.Students.forEach(student => {
                    const sId = typeof student === 'number' ? student : (student.Id || student.User?.Id || student.UserId);
                    if (sId && !state.selectedStudent.includes(sId)) {
                        state.selectedStudent.push(sId);
                    }
                });
            }
            state.date = (props.item.StartDate && props.item.EndDate) ? `${props.item.StartDate} - ${props.item.EndDate}` : "";
            state.isFirst = false;
            state.SelectCustomeQuestions = Boolean(props.item.customLesson);
            if (props.SelectedQuestions && props.SelectedQuestions.length > 0) {
                state.SelectedQuestions = props.SelectedQuestions;
            } else if (props.item.Questions && props.item.Questions.length > 0) {
                state.SelectedQuestions = props.item.Questions.map(q => typeof q === 'object' ? q.Id : q);
            } else if (props.item.Lesson?.Questions && props.item.Lesson.Questions.length > 0) {
                state.SelectedQuestions = props.item.Lesson.Questions.map(q => typeof q === 'object' ? q.Id : q);
            }
        }

        return state;
    }

    extractSkills = (lesson) => {
        if (!lesson) return [];
        const skillsMap = new Map();

        if (lesson.Skills && Array.isArray(lesson.Skills)) {
            lesson.Skills.forEach(s => {
                const id = s.Id || s.SkillId;
                const name = s.Name || s.SkillName;
                if (id && name && !skillsMap.has(id)) {
                    skillsMap.set(id, { id, name, domain: s.DomainName || s.Domain?.Name || '' });
                }
            });
        }

        if (lesson.Questions && Array.isArray(lesson.Questions)) {
            lesson.Questions.forEach(q => {
                if (q.Skills && Array.isArray(q.Skills)) {
                    q.Skills.forEach(s => {
                        const id = s.Id || s.SkillId;
                        const name = s.Name || s.SkillName;
                        if (id && name && !skillsMap.has(id)) {
                            skillsMap.set(id, { id, name, domain: s.DomainName || s.Domain?.Name || '' });
                        }
                    });
                } else if (q.Skill) {
                    const id = q.Skill.Id || q.Skill.SkillId;
                    const name = q.Skill.Name || q.Skill.SkillName;
                    if (id && name && !skillsMap.has(id)) {
                        skillsMap.set(id, { id, name, domain: q.Skill.DomainName || q.Skill.Domain?.Name || '' });
                    }
                }
            });
        }

        return Array.from(skillsMap.values());
    };

    setSelectCustomeQuestions = SelectCustomeQuestions => {
        this.setState({ SelectCustomeQuestions });
        if (SelectCustomeQuestions && this.props.lessonQuestions && this.props.lessonQuestions.LessonId !== this.props.LessonId) {
            this.props.clearLessonQuestions && this.props.clearLessonQuestions();
        }
    };

    setSelectQuestions = SelectedQuestions => {
        this.setState({ SelectedQuestions });
        if (this.props.setSelect) {
            this.props.setSelect(SelectedQuestions);
        }
    };

    setSelect = selectedStudent => {
        let result = [...this.state.selectedStudent];
        selectedStudent.forEach(item => {
            if (!result.includes(item)) {
                result.push(item);
            }
        });
        this.setState({ selectedStudent: result });
    };

    setDeselect = selectedStudent => {
        let result = this.state.selectedStudent.filter(ele => !selectedStudent.includes(ele));
        this.setState({ selectedStudent: result });
    };

    getClassRoomsList = () => {
        const raw = this.props.classRooms;
        if (Array.isArray(raw)) return raw;
        if (raw && Array.isArray(raw.classRooms)) return raw.classRooms;
        return [];
    };

    selectAllGlobalStudents = () => {
        const classRoomsList = this.getClassRoomsList();
        const allStudentIds = [];
        classRoomsList.forEach(cr => {
            (cr.Students || []).forEach(s => {
                const sId = s.Id;
                if (sId && !allStudentIds.includes(sId)) {
                    allStudentIds.push(sId);
                }
            });
        });
        this.setState({ selectedStudent: allStudentIds });
    };

    deselectAllGlobalStudents = () => {
        this.setState({ selectedStudent: [] });
    };

    handleApplyDate = (event, picker) => {
        const formattedDate = picker.startDate.format('DD/MM/YYYY hh:mm A') + " - " + picker.endDate.format('DD/MM/YYYY hh:mm A');
        picker.element.val(formattedDate);
        this.setState({
            date: formattedDate,
            startDate: picker.startDate.format('DD/MM/YYYY hh:mm A'),
            endDate: picker.endDate.format('DD/MM/YYYY hh:mm A')
        });
    };

    setTimeHour = TimeHour => {
        if (TimeHour >= 0 && TimeHour < 24) {
            this.setState({ TimeHour });
        }
    };

    setTimeMinutes = TimeMinutes => {
        if (TimeMinutes >= 0 && TimeMinutes < 60) {
            this.setState({ TimeMinutes });
        }
    };

    setTimeType = TimeType => {
        this.setState({ TimeType });
    };

    setGamePlay = GamePlay => {
        this.setState({ GamePlay });
    };

    setGameSave = GameSave => {
        this.setState({ GameSave });
    };

    goToStep = (targetStep) => {
        const { t, lesson } = this.props;
        const { currentStep, startDate, endDate, TimeType, TimeHour, TimeMinutes, SelectCustomeQuestions, SelectedQuestions } = this.state;

        if (targetStep > currentStep) {
            if (currentStep === 1) {
                if (!startDate || !endDate) {
                    toast.error(t('Pages.Missions.error_date_toast.Title') || 'يرجى تحديد فترة المهمة أولاً');
                    return;
                }
                if (lesson.isGame !== true && TimeType === 'stoped') {
                    const sum = (TimeHour ? parseInt(TimeHour) : 0) + (TimeMinutes ? parseInt(TimeMinutes) : 0);
                    if (!sum) {
                        this.setState({ TimeMinutes: 30, TimeHour: 0 });
                    }
                }
            } else if (currentStep === 2) {
                if (SelectCustomeQuestions) {
                    const count = (SelectedQuestions && SelectedQuestions.length > 0) ? SelectedQuestions.length : (this.props.SelectedQuestions || []).length;
                    if (count === 0) {
                        toast.error(t('Pages.Missions.SelectAtLeastOneQuestion') || 'يرجى اختيار سؤال واحد على الأقل للمهمة المخصصة');
                        return;
                    }
                }
            }
        }

        this.setState({ currentStep: targetStep });
    };

    submit = () => {
        const { t, lesson } = this.props;

        this._toastId.current = toast(t('Processing') || 'جارٍ المعالجة...', {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(this._toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner ml-1"></i> {t('Processing') || 'جارٍ المعالجة...'} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        const sum = lesson.isGame === true ? 1 : parseInt((this.state.TimeHour ? this.state.TimeHour : 0) + (this.state.TimeMinutes ? this.state.TimeMinutes : 0));

        const selectedQuestionsList = (this.state.SelectedQuestions && this.state.SelectedQuestions.length > 0)
            ? this.state.SelectedQuestions
            : (this.props.SelectedQuestions || []);

        let postData = {
            LessonId: lesson.Id,
            endDate: this.state.endDate,
            startDate: this.state.startDate,
            selectedStudent: this.state.selectedStudent,
            Questions: this.state.SelectCustomeQuestions ? selectedQuestionsList : null
        };

        if (this.state.selectedStudent.length === 0) {
            toast.update(this._toastId.current, {
                render: () => (
                    <div>
                        <div className="h5 font-weight-bold">
                            <i className="icon fal fa-users-slash ml-1"></i>
                            {t('Pages.Missions.error_student_not_selected_toast.Title') || 'لم يتم اختيار أي طالب'}
                        </div>
                        <div className="h6">
                            {t('Pages.Missions.error_student_not_selected_toast.Body') || 'يرجى تحديد صف واحد أو طالب واحد على الأقل للمهمة'}
                        </div>
                    </div>
                ),
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true
            });
            this.setState({ currentStep: 3 });
        } else if (!this.state.startDate || !this.state.endDate) {
            toast.update(this._toastId.current, {
                render: () => (
                    <div>
                        <div className="h5 font-weight-bold">
                            <i className="icon fal fa-calendar-times ml-1"></i>
                            {t('Pages.Missions.error_date_toast.Title') || 'تاريخ غير محدد'}
                        </div>
                        <div className="h6">
                            {t('Pages.Missions.error_date_toast.Body') || 'يرجى تحديد تاريخ ووقت البدء والانتهاء'}
                        </div>
                    </div>
                ),
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true
            });
            this.setState({ currentStep: 1 });
        } else if (this.state.TimeType === "stoped" && !sum && lesson.isGame !== true) {
            toast.update(this._toastId.current, {
                render: () => (
                    <div>
                        <div className="h5 font-weight-bold">
                            <i className="icon fal fa-hourglass-end ml-1"></i>
                            {t('Pages.Missions.error_time_toast.Title') || 'المؤقت غير محدد'}
                        </div>
                        <div className="h6">
                            {t('Pages.Missions.error_time_toast.Body') || 'يرجى تحديد الساعات أو الدقائق للمؤقت'}
                        </div>
                    </div>
                ),
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true
            });
            this.setState({ currentStep: 1 });
        } else {
            if (lesson.isGame === true) {
                postData = {
                    ...postData,
                    CustomStyle: {
                        GamePlay: this.state.GamePlay,
                        GameSave: this.state.GameSave,
                    }
                };
            } else {
                postData = {
                    ...postData,
                    CustomStyle: {
                        Clock: {
                            TimeHour: parseInt(this.state.TimeHour) || 0,
                            TimeMinutes: parseInt(this.state.TimeMinutes) || 0,
                            TimeType: this.state.TimeType
                        }
                    }
                };
            }

            if (this.state.Id) {
                api.put(`/Missions/${this.state.Id}`, postData)
                    .then(() => {
                        toast.update(this._toastId.current, {
                            render: () => (
                                <div>
                                    <div className="h5 font-weight-bold">
                                        <i className="icon fal fa-shield-check ml-1"></i>
                                        {t('Pages.Missions.success_update_toast.Title') || 'تم تحديث المهمة بنجاح'}
                                    </div>
                                    <div className="h6">
                                        {t('Pages.Missions.success_update_toast.Body') || 'تم حفظ جميع تعديلات المهمة وإخطار الطلاب'}
                                    </div>
                                </div>
                            ),
                            type: toast.TYPE.SUCCESS,
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true
                        });

                        this.props.Sync && this.props.Sync();
                        this.props.handleClose();
                        ShareMissionBySocket(postData.selectedStudent, {
                            ...lesson,
                            Id: this.state.Id
                        });
                    })
                    .catch(() => {
                        toast.update(this._toastId.current, {
                            render: () => (
                                <div>
                                    <div className="h5 font-weight-bold"><i className="icon fal fa-wifi-slash ml-1"></i> {t('Error.NoConnection.Title') || 'خطأ في الاتصال'}</div>
                                    <div className="h6">{t('Error.NoConnection.Body') || 'تعذر حفظ تعديلات المهمة'}</div>
                                </div>
                            ),
                            type: toast.TYPE.ERROR,
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true
                        });
                    });
            } else {
                api.post(`/Missions/`, postData)
                    .then(response => {
                        toast.update(this._toastId.current, {
                            render: () => (
                                <div>
                                    <div className="h5 font-weight-bold">
                                        <i className="icon fal fa-bullseye-arrow ml-1"></i>
                                        {t('Pages.Missions.success_toast.Title') || 'تم إرسال المهمة بنجاح'}
                                    </div>
                                    <div className="h6">
                                        {t('Pages.Missions.success_toast.Body') || 'تم إسناد المهمة للطلاب المحددين بنجاح'}
                                    </div>
                                </div>
                            ),
                            type: toast.TYPE.SUCCESS,
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true
                        });

                        this.props.Sync && this.props.Sync();
                        this.props.handleClose();
                        ShareMissionBySocket(postData.selectedStudent, {
                            ...lesson,
                            Id: response.data.Id
                        });
                    })
                    .catch(() => {
                        toast.update(this._toastId.current, {
                            render: () => (
                                <div>
                                    <div className="h5 font-weight-bold"><i className="icon fal fa-wifi-slash ml-1"></i> {t('Error.NoConnection.Title') || 'خطأ في الاتصال'}</div>
                                    <div className="h6">{t('Error.NoConnection.Body') || 'تعذر إرسال المهمة للطلاب'}</div>
                                </div>
                            ),
                            type: toast.TYPE.ERROR,
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true
                        });
                    });
            }
        }
    };

    sortClassRoomsByGradeAndSection = (classList = []) => {
        const gradeOrder = ['أول', 'ثاني', 'ثالث', 'رابع', 'خامس', 'سادس', 'سابع', 'ثامن', 'تاسع', 'عاشر', 'حادي عشر', 'ثاني عشر', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

        const parseGradeAndSection = (name = '') => {
            let gradeIndex = 999;
            let gradeName = name;
            let section = '';

            if (name.includes(' - ')) {
                const parts = name.split(' - ');
                gradeName = parts[0].trim();
                section = parts.slice(1).join(' - ').trim();
            } else {
                const match = name.match(/^(.*)\s+([أ-يa-zA-Z0-9])$/);
                if (match) {
                    gradeName = match[1].trim();
                    section = match[2].trim();
                }
            }

            gradeOrder.forEach((g, idx) => {
                if (gradeName.includes(g)) {
                    gradeIndex = idx;
                }
            });

            return { gradeIndex, gradeName, section };
        };

        return [...classList].sort((a, b) => {
            const pA = parseGradeAndSection(a.Name || '');
            const pB = parseGradeAndSection(b.Name || '');
            if (pA.gradeIndex !== pB.gradeIndex) {
                return pA.gradeIndex - pB.gradeIndex;
            }
            if (pA.gradeName !== pB.gradeName) {
                return pA.gradeName.localeCompare(pB.gradeName, 'ar');
            }
            return (pA.section || '').localeCompare(pB.section || '', 'ar');
        });
    };

    render() {
        const { t, lesson } = this.props;
        const { currentStep, classSearchTerm, selectedStudent, SelectCustomeQuestions, TimeType } = this.state;

        if (!lesson) return null;

        const classRoomsList = this.getClassRoomsList();
        const totalClassStudents = classRoomsList.reduce((acc, cr) => acc + (cr.Students?.length || 0), 0);
        const filteredClassRooms = classRoomsList.filter(cr => {
            if (!classSearchTerm) return true;
            return cr.Name?.toLowerCase().includes(classSearchTerm.toLowerCase());
        });
        const sortedClassRooms = this.sortClassRoomsByGradeAndSection(filteredClassRooms);

        const isEditing = Boolean(this.props.item || this.state.Id);

        return (
            <Modal
                centered
                key="ModalSendMission"
                size="xl"
                show={true}
                onHide={() => this.props.handleClose()}
                backdrop="static"
                keyboard={false}
                enforceFocus={false}
                dialogClassName="modal-send-mission"
            >
                {/* Modal Header */}
                <Modal.Header closeButton className="border-bottom-0 pb-1 pt-3 px-4 bg-white">
                    <div className="d-flex align-items-center">
                        <span className="kpi-icon-wrap kpi-icon--indigo ml-2" style={{ width: '38px', height: '38px', fontSize: '1rem' }}>
                            <i className={isEditing ? "fas fa-edit" : "fas fa-paper-plane"}></i>
                        </span>
                        <div>
                            <h5 className="font-weight-bold mb-0 text-dark">
                                {isEditing
                                    ? (t('Pages.Missions.EditMission') || 'تعديل بيانات المهمة والواجب')
                                    : (t('Pages.Missions.SendMission') || 'إرسال المهمة للطلاب')
                                }
                            </h5>
                            <span className="small text-muted">
                                {lesson.isGame ? (t('Pages.Missions.EducationalGame') || 'لعبة تعليمية') : (t('Pages.Missions.InteractiveLesson') || 'درس تفاعلي')} • {lesson.Name}
                            </span>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-4 pt-2">
                    {/* 1. Hero Overview of Lesson & Bio (Similar to Summary Screen) */}
                    <div className="send-mission-hero mb-3 anim-rise">
                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                            <div className="d-flex align-items-center mb-2 mb-md-0">
                                {lesson.Icon ? (
                                    <img
                                        src={lesson.Icon}
                                        alt={lesson.Name}
                                        className="rounded-circle ml-3 border"
                                        style={{ width: '48px', height: '48px', objectFit: 'cover', borderColor: 'rgba(255,255,255,0.4)', backgroundColor: '#ffffff' }}
                                    />
                                ) : lesson.ImageUrl ? (
                                    <img
                                        src={lesson.ImageUrl}
                                        alt={lesson.Name}
                                        className="rounded-circle ml-3 border"
                                        style={{ width: '48px', height: '48px', objectFit: 'cover', borderColor: 'rgba(255,255,255,0.4)' }}
                                    />
                                ) : (
                                    <img
                                        src="/assets/images/logo/130p150.png"
                                        alt={lesson.Name}
                                        className="rounded-circle ml-3 border"
                                        style={{ width: '48px', height: '48px', objectFit: 'cover', borderColor: 'rgba(255,255,255,0.4)' }}
                                    />
                                )}
                                <div>
                                    <h6 className="font-weight-bold mb-1 text-white" style={{ fontSize: '1.05rem' }}>
                                        {lesson.Name}
                                    </h6>
                                    <div className="small text-white-50 d-flex align-items-center" style={{ gap: '12px' }}>
                                        {lesson.TotalMark > 0 && (
                                            <span>
                                                <i className="fas fa-award ml-1 text-warning"></i>
                                                {t('Pages.Missions.TotalMarkLabel') || 'العلامة الكلية'}: <strong>{lesson.TotalMark}</strong>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Lesson Bio */}
                        {lesson.Bio && (
                            <div className="mt-3 pt-2 border-top" style={{ borderColor: 'rgba(255, 255, 255, 0.18)' }}>
                                <div className="small text-white d-flex align-items-start" style={{ opacity: 0.92, lineHeight: 1.6 }}>
                                    <i className="fas fa-quote-right ml-2 mt-1 text-warning" style={{ fontSize: '0.85rem' }}></i>
                                    <span dangerouslySetInnerHTML={{ __html: lesson.Bio }}></span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* 2. Three-Step Wizard Navigation */}
                    <div className="wizard-stepper anim-fade-up">
                        {/* Step 1 Node */}
                        <div
                            className={`wizard-step-node ${currentStep === 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}
                            onClick={() => this.goToStep(1)}
                        >
                            <div className="wizard-step-circle">
                                {currentStep > 1 ? <i className="fas fa-check"></i> : '1'}
                            </div>
                            <div className="wizard-step-text">
                                <div className="wizard-step-title">{t('Pages.Missions.SendMissionSteps.Step1Title') || 'الفترة والوقت'}</div>
                                <div className="wizard-step-sub">{t('Pages.Missions.SendMissionSteps.Step1Desc') || 'التاريخ والمؤقت'}</div>
                            </div>
                        </div>

                        <div className={`wizard-step-separator ${currentStep > 1 ? 'active' : ''}`}></div>

                        {/* Step 2 Node */}
                        <div
                            className={`wizard-step-node ${currentStep === 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}
                            onClick={() => this.goToStep(2)}
                        >
                            <div className="wizard-step-circle">
                                {currentStep > 2 ? <i className="fas fa-check"></i> : '2'}
                            </div>
                            <div className="wizard-step-text">
                                <div className="wizard-step-title">{t('Pages.Missions.SendMissionSteps.Step2Title') || 'الأسئلة والمحتوى'}</div>
                                <div className="wizard-step-sub">{t('Pages.Missions.SendMissionSteps.Step2Desc') || 'كامل الدرس أو مخصص'}</div>
                            </div>
                        </div>

                        <div className={`wizard-step-separator ${currentStep > 2 ? 'active' : ''}`}></div>

                        {/* Step 3 Node */}
                        <div
                            className={`wizard-step-node ${currentStep === 3 ? 'active' : ''}`}
                            onClick={() => this.goToStep(3)}
                        >
                            <div className="wizard-step-circle">
                                3
                            </div>
                            <div className="wizard-step-text">
                                <div className="wizard-step-title">{t('Pages.Missions.SendMissionSteps.Step3Title') || 'الصفوف والطلاب'}</div>
                                <div className="wizard-step-sub">
                                    {selectedStudent.length > 0 ? `${selectedStudent.length} ${t('Student') || 'طالب'}` : (t('Pages.Missions.SendMissionSteps.Step3Desc') || 'تحديد المستهدفين')}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 3. Step Content Panels */}
                    <div className="step-content-body">
                        {/* ---------------- STEP 1: PERIOD & TIME SETTINGS ---------------- */}
                        {currentStep === 1 && (
                            <div className="anim-rise">
                                <div className="card border-0 shadow-2xs p-3 mb-3 bg-white" style={{ borderRadius: '14px', border: '1px solid #e2e8f0' }}>
                                    <label className="font-weight-bold text-dark d-flex align-items-center mb-2" style={{ fontSize: '0.95rem' }}>
                                        <i className="fas fa-calendar-alt text-primary ml-2"></i>
                                        <span>{t('Pages.Missions.Date.title') || 'الفترة الزمنية المحددة للحل'}</span>
                                        <i title={t('required')} className="fas fa-star-of-life font-size-10 text-danger mr-1"></i>
                                    </label>
                                    <DateRangePicker
                                        ref={Date => this.Date = Date}
                                        initialSettings={{
                                            opens: 'center',
                                            autoUpdateInput: false,
                                            buttonClasses: 'btn',
                                            cancelClass: "btn-danger",
                                            applyButtonClasses: "btn-primary",
                                            showDropdowns: true,
                                            timePicker: true,
                                            startDate: this.state.startDate ? moment(this.state.startDate, 'DD/MM/YYYY hh:mm A') : undefined,
                                            endDate: this.state.endDate ? moment(this.state.endDate, 'DD/MM/YYYY hh:mm A') : undefined,
                                            minDate: `${moment().format('DD/MM/YYYY')}`,
                                            minYear: 2021,
                                            locale: {
                                                format: 'DD/MM/YYYY hh:mm A',
                                                cancelLabel: t('Close') || 'إلغاء',
                                                firstDay: 6,
                                                applyLabel: t('Apply') || 'تطبيق',
                                                customRangeLabel: t('range.customRange') || 'مخصص',
                                                monthNames: [
                                                    `${t("months.January") || 'يناير'}`,
                                                    `${t("months.February") || 'فبراير'}`,
                                                    `${t("months.March") || 'مارس'}`,
                                                    `${t("months.April") || 'أبريل'}`,
                                                    `${t("months.May") || 'مايو'}`,
                                                    `${t("months.June") || 'يونيو'}`,
                                                    `${t("months.July") || 'يوليو'}`,
                                                    `${t("months.August") || 'أغسطس'}`,
                                                    `${t("months.September") || 'سبتمبر'}`,
                                                    `${t("months.October") || 'أكتوبر'}`,
                                                    `${t("months.November") || 'نوفمبر'}`,
                                                    `${t("months.December") || 'ديسمبر'}`
                                                ],
                                                daysOfWeek: [
                                                    t("daysOfWeek.Sunday") || 'أحد',
                                                    t("daysOfWeek.Monday") || 'اثنين',
                                                    t("daysOfWeek.Tuesday") || 'ثلاثاء',
                                                    t("daysOfWeek.Wednesday") || 'أربعاء',
                                                    t("daysOfWeek.Thursday") || 'خميس',
                                                    t("daysOfWeek.Friday") || 'جمعة',
                                                    t("daysOfWeek.Saturday") || 'سبت'
                                                ],
                                            },
                                        }}
                                        onApply={this.handleApplyDate}
                                    >
                                        <div className="input-group">
                                            <input
                                                value={this.state.date || ''}
                                                name="Date"
                                                readOnly={true}
                                                autoComplete="off"
                                                required
                                                type="text"
                                                className="form-control font-weight-bold"
                                                style={{ fontSize: '0.9rem', cursor: 'pointer', backgroundColor: '#ffffff', borderRadius: '0 10px 10px 0' }}
                                                placeholder={t('Pages.Missions.Date.Placeholder') || 'انقر لتحديد تاريخ ووقت البدء والانتهاء...'}
                                                title={t('Pages.Missions.Date.title')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text bg-light border-right-0" style={{ borderRadius: '10px 0 0 10px' }}>
                                                    <i className="fas fa-calendar-alt text-primary"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </DateRangePicker>
                                    <div className="small text-muted mt-2">
                                        <i className="fas fa-info-circle ml-1 text-info"></i>
                                        {t('Pages.Missions.DateHint') || 'يستطيع الطلاب الدخول والحل فقط ضمن الفترة المحددة أعلاه.'}
                                    </div>
                                </div>

                                {/* Timer Mode / Clock Settings */}
                                {lesson.isGame !== true ? (
                                    <div className="card border-0 shadow-2xs p-3 bg-white" style={{ borderRadius: '14px', border: '1px solid #e2e8f0' }}>
                                        <label className="font-weight-bold text-dark d-flex align-items-center mb-3" style={{ fontSize: '0.95rem' }}>
                                            <i className="fas fa-stopwatch text-warning ml-2"></i>
                                            <span>{t('Pages.Missions.TimerMode') || 'نظام مؤقت الحل والوقت'}</span>
                                        </label>

                                        <div className="row">
                                            {/* Option 1: Continue Time Mode */}
                                            <div className="col-md-6 mb-2">
                                                <div
                                                    className={`selectable-option-card ${TimeType === 'continue' ? 'selected' : ''}`}
                                                    onClick={() => this.setTimeType('continue')}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-history text-primary ml-2" style={{ fontSize: '1.1rem' }}></i>
                                                            <h6 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '0.92rem' }}>
                                                                {t('Pages.Missions.SendMissionSteps.TimerModeContinueTitle') || 'وقت مرن (السماح بمتابعة الحل)'}
                                                            </h6>
                                                        </div>
                                                        <div className="card-select-radio">
                                                            {TimeType === 'continue' && <i className="fas fa-check"></i>}
                                                        </div>
                                                    </div>
                                                    <p className="small text-muted mb-0">
                                                        {t('Pages.Missions.SendMissionSteps.TimerModeContinueDesc') || 'تحديد وقت قياسي للحل مع السماح للطالب بمواصلة الإجابة بعد انتهاء الوقت (مع احتساب زمن الإنجاز الفعلي).'}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Option 2: Fixed Stop Timer Mode */}
                                            <div className="col-md-6 mb-2">
                                                <div
                                                    className={`selectable-option-card ${TimeType === 'stoped' ? 'selected' : ''}`}
                                                    onClick={() => this.setTimeType('stoped')}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-hourglass-half text-warning ml-2" style={{ fontSize: '1.1rem' }}></i>
                                                            <h6 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '0.92rem' }}>
                                                                {t('Pages.Missions.SendMissionSteps.TimerModeStoppedTitle') || 'مؤقت إلزامي (إنهاء وتسليم تلقائي)'}
                                                            </h6>
                                                        </div>
                                                        <div className="card-select-radio">
                                                            {TimeType === 'stoped' && <i className="fas fa-check"></i>}
                                                        </div>
                                                    </div>
                                                    <p className="small text-muted mb-0">
                                                        {t('Pages.Missions.SendMissionSteps.TimerModeStoppedDesc') || 'إنهاء جلسة الاختبار وتسليم الإجابات تلقائياً فور انتهاء الوقت المحدد.'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Timer Fields (Always Visible for All Timer Modes) */}
                                        <div className="p-3 mt-3 rounded bg-light border">
                                            <div className="row">
                                                <div className="col-6">
                                                    <label className="text-dark font-weight-bold small mb-1">
                                                        <i className="fas fa-clock ml-1 text-primary"></i>
                                                        {t('Pages.Missions.TimeHour.title') || 'الساعات'}
                                                    </label>
                                                    <input
                                                        className="form-control text-center font-weight-bold"
                                                        type="number"
                                                        step="1"
                                                        min="0"
                                                        max="23"
                                                        placeholder="0"
                                                        value={this.state.TimeHour}
                                                        onChange={e => this.setTimeHour(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label className="text-dark font-weight-bold small mb-1">
                                                        <i className="fas fa-hourglass-start ml-1 text-primary"></i>
                                                        {t('Pages.Missions.TimeMinutes.title') || 'الدقائق'}
                                                    </label>
                                                    <input
                                                        className="form-control text-center font-weight-bold"
                                                        type="number"
                                                        step="1"
                                                        min="0"
                                                        max="59"
                                                        placeholder="0"
                                                        value={this.state.TimeMinutes}
                                                        onChange={e => this.setTimeMinutes(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="small text-muted mt-2 pt-2 border-top">
                                                <i className="fas fa-info-circle ml-1 text-info"></i>
                                                {t('Pages.Missions.TimerBenchmarkHint') || 'يُعتمد هذا الوقت كمعيار لقياس سرعة وإتقان الطالب في التصحيح والتقييم (يستطيع الطالب إكمال الحل بعد تجاوز المدة مع احتساب زمن الإنجاز الفعلي).'}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    /* Game Play and Save Settings */
                                    <div className="card border-0 shadow-2xs p-3 bg-white" style={{ borderRadius: '14px', border: '1px solid #e2e8f0' }}>
                                        <label className="font-weight-bold text-dark d-flex align-items-center mb-3" style={{ fontSize: '0.95rem' }}>
                                            <i className="fas fa-gamepad text-secondary ml-2"></i>
                                            <span>{t('Pages.Missions.GameSettings') || 'إعدادات اللعبة وحفظ التقدم'}</span>
                                        </label>
                                        <div className="row">
                                            <div className="col-md-6 mb-2">
                                                <label className="small text-muted font-weight-bold mb-1">{t('Pages.Missions.GamePlay.title') || 'نمط اللعب'}</label>
                                                <select
                                                    className="form-control"
                                                    value={this.state.GamePlay}
                                                    onChange={e => this.setGamePlay(e.target.value)}
                                                >
                                                    <option value="default">{t('Pages.Missions.GamePlay.default') || 'افتراضي'}</option>
                                                    <option value="open">{t('Pages.Missions.GamePlay.open') || 'مفتوح'}</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="small text-muted font-weight-bold mb-1">{t('Pages.Missions.GameSave.title') || 'حفظ التقدم'}</label>
                                                <select
                                                    className="form-control"
                                                    value={this.state.GameSave}
                                                    onChange={e => this.setGameSave(e.target.value)}
                                                >
                                                    <option value="default">{t('Pages.Missions.GameSave.default') || 'افتراضي'}</option>
                                                    <option value="lastStage">{t('Pages.Missions.GameSave.lastStage') || 'آخر مرحلة'}</option>
                                                    <option value="medium">{t('Pages.Missions.GameSave.medium') || 'متوسط'}</option>
                                                    <option value="hard">{t('Pages.Missions.GameSave.hard') || 'صعب'}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ---------------- STEP 2: CONTENT & QUESTIONS SCOPE ---------------- */}
                        {currentStep === 2 && (
                            <div className="anim-rise">
                                <div className="row mb-3">
                                    {/* Option 1: Full Lesson Scope */}
                                    <div className="col-md-6 mb-2">
                                        <div
                                            className={`selectable-option-card ${!SelectCustomeQuestions ? 'selected' : ''}`}
                                            onClick={() => this.setSelectCustomeQuestions(false)}
                                        >
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-book-reader text-success ml-2" style={{ fontSize: '1.15rem' }}></i>
                                                    <h6 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '0.92rem' }}>
                                                        {t('Pages.Missions.SendMissionSteps.ScopeFullLessonTitle') || 'كامل الدرس (جميع الأسئلة)'}
                                                    </h6>
                                                </div>
                                                <div className="card-select-radio">
                                                    {!SelectCustomeQuestions && <i className="fas fa-check"></i>}
                                                </div>
                                            </div>
                                            <p className="small text-muted mb-0">
                                                {t('Pages.Missions.SendMissionSteps.ScopeFullLessonDesc') || 'إسناد جميع الأسئلة والأنشطة المتوفرة في الدرس للطلاب بشكل كامل.'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Option 2: Custom Questions Selection */}
                                    <div className="col-md-6 mb-2">
                                        <div
                                            className={`selectable-option-card ${SelectCustomeQuestions ? 'selected' : ''}`}
                                            onClick={() => this.setSelectCustomeQuestions(true)}
                                        >
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-tasks text-warning ml-2" style={{ fontSize: '1.15rem' }}></i>
                                                    <h6 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '0.92rem' }}>
                                                        {t('Pages.Missions.SendMissionSteps.ScopeCustomQuestionsTitle') || 'تخصيص أسئلة محددة من الدرس'}
                                                    </h6>
                                                </div>
                                                <div className="card-select-radio">
                                                    {SelectCustomeQuestions && <i className="fas fa-check"></i>}
                                                </div>
                                            </div>
                                            <p className="small text-muted mb-0">
                                                {t('Pages.Missions.SendMissionSteps.ScopeCustomQuestionsDesc') || 'انتقاء مجموعة محددة من أسئلة ومهارات الدرس للمهمة فقط.'}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Custom Questions Interactive List */}
                                {SelectCustomeQuestions && (
                                    <div className="card border-0 shadow-2xs p-3 bg-white anim-fade-up" style={{ borderRadius: '14px', border: '1px solid #e2e8f0' }}>
                                        <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                                            <span className="font-weight-bold text-dark small">
                                                <i className="fas fa-list-check text-primary ml-1"></i>
                                                {t('Pages.Missions.CustomQuestionsList') || 'قائمة الأسئلة المتاحة للتخصيص'}
                                            </span>
                                            <span className="badge badge-primary px-3 py-1 font-weight-bold" style={{ borderRadius: '12px' }}>
                                                {this.state.SelectedQuestions?.length || this.props.SelectedQuestions?.length || 0} {t('QuestionsCount') || 'سؤال مختار'}
                                            </span>
                                        </div>
                                        <LessonQuestionsList
                                            SelectedQuestions={this.state.SelectedQuestions && this.state.SelectedQuestions.length > 0 ? this.state.SelectedQuestions : this.props.SelectedQuestions}
                                            LessonId={lesson.Id}
                                            lesson={lesson}
                                            setSelect={this.setSelectQuestions}
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ---------------- STEP 3: CLASSROOMS & STUDENTS ---------------- */}
                        {currentStep === 3 && (
                            <div className="anim-rise">
                                <div className="card border-0 shadow-2xs p-3 bg-white" style={{ borderRadius: '14px', border: '1px solid #e2e8f0' }}>
                                    {/* Header Actions & Search Bar */}
                                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 pb-2 border-bottom" style={{ gap: '10px' }}>
                                        <div className="d-flex align-items-center">
                                            <span className="kpi-icon-wrap kpi-icon--emerald ml-2" style={{ width: '32px', height: '32px', fontSize: '0.85rem' }}>
                                                <i className="fas fa-users-class"></i>
                                            </span>
                                            <div>
                                                <span className="font-weight-bold text-dark" style={{ fontSize: '0.92rem' }}>
                                                    {t('Pages.Missions.TargetClassrooms') || 'تحديد الشُعب والطلاب'}
                                                </span>
                                                <div className="small text-muted">
                                                    {t('Pages.Missions.SendMissionSteps.SelectedStudentsCount') || 'الطلاب المختارين'}:{' '}
                                                    <strong className="text-primary">{selectedStudent.length}</strong> / {totalClassStudents}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                            <button
                                                type="button"
                                                className="btn btn-xs btn-outline-primary px-2 py-1 font-weight-bold"
                                                onClick={this.selectAllGlobalStudents}
                                                style={{ fontSize: '0.74rem', borderRadius: '8px' }}
                                            >
                                                <i className="fas fa-check-double ml-1"></i>
                                                {t('Pages.Missions.SendMissionSteps.SelectAllStudents') || 'تحديد الكل'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-xs btn-outline-secondary px-2 py-1 font-weight-bold"
                                                onClick={this.deselectAllGlobalStudents}
                                                style={{ fontSize: '0.74rem', borderRadius: '8px' }}
                                            >
                                                <i className="fas fa-times ml-1"></i>
                                                {t('Pages.Missions.SendMissionSteps.DeselectAllStudents') || 'إلغاء التحديد'}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Classrooms Search Filter */}
                                    <div className="form-group mb-3">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text bg-light border-left-0">
                                                    <i className="fas fa-search text-muted"></i>
                                                </span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={t('Pages.Missions.SearchClassroomPlaceholder') || 'بحث في أسماء الصفوف والشُعب...'}
                                                value={classSearchTerm}
                                                onChange={e => this.setState({ classSearchTerm: e.target.value })}
                                                style={{ fontSize: '0.85rem' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Classrooms Tree List */}
                                    <div style={{ maxHeight: '320px', overflowY: 'auto' }} className="pr-1 pl-1">
                                        {filteredClassRooms.length === 0 ? (
                                            <div className="text-center py-4 text-muted">
                                                <i className="fas fa-exclamation-triangle ml-1 text-warning"></i>
                                                {t('Error.NotClassSelected.Title') || "لا توجد صفوف دراسية متاحة"}
                                            </div>
                                        ) : (
                                            <ul className="pl-0 mb-0">
                                                {sortedClassRooms.map(classRoom => (
                                                    <ClassRoomItem
                                                        setSelect={this.setSelect}
                                                        setDeselect={this.setDeselect}
                                                        selectedStudent={this.state.selectedStudent}
                                                        classRoom={classRoom}
                                                        key={`className-${classRoom.Id}`}
                                                    />
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>

                {/* Modal Footer Navigation */}
                <Modal.Footer className="bg-white border-top d-flex justify-content-between align-items-center py-3 px-4">
                    {/* Status & Summary Chip */}
                    <div className="d-none d-md-flex align-items-center text-muted small" style={{ gap: '8px' }}>
                        <span className="badge badge-light border px-2 py-1">
                            <i className="fas fa-calendar-alt text-primary ml-1"></i>
                            {this.state.startDate ? this.state.startDate.split(' ')[0] : 'تاريخ غير محدد'}
                        </span>
                        <span className="badge badge-light border px-2 py-1">
                            <i className="fas fa-users text-success ml-1"></i>
                            {selectedStudent.length} {t('Student') || 'طالب'}
                        </span>
                    </div>

                    {/* Navigation Buttons */}
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                        {currentStep > 1 && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary font-weight-bold px-3 py-2"
                                onClick={() => this.goToStep(currentStep - 1)}
                                style={{ borderRadius: '10px', fontSize: '0.85rem' }}
                            >
                                <i className="fas fa-arrow-right ml-1"></i>
                                {t('Pages.Missions.SendMissionSteps.PrevStep') || 'السابق'}
                            </button>
                        )}

                        {currentStep < 3 ? (
                            <button
                                type="button"
                                className="btn btn-primary font-weight-bold px-4 py-2"
                                onClick={() => this.goToStep(currentStep + 1)}
                                style={{ borderRadius: '10px', fontSize: '0.85rem', background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)', border: 'none' }}
                            >
                                <span>{t('Pages.Missions.SendMissionSteps.NextStep') || 'التالي'}</span>
                                <i className="fas fa-arrow-left mr-1"></i>
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-success font-weight-bold px-4 py-2 shadow-sm"
                                onClick={this.submit}
                                style={{ borderRadius: '10px', fontSize: '0.85rem', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', border: 'none' }}
                            >
                                <i className={`icon ml-1 ${isEditing ? 'fal fa-save' : 'fal fa-bullseye-arrow'}`}></i>
                                <span>
                                    {isEditing
                                        ? (t('Pages.Missions.SendMissionSteps.UpdateMissionNow') || 'حفظ تحديثات المهمة')
                                        : (t('Pages.Missions.SendMissionSteps.SendMissionNow') || 'إرسال المهمة للطلاب')
                                    }
                                </span>
                            </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation('common')(SendMissionForm);